import {
  components,
  GroupBase,
  InputProps,
  MultiValue,
  OptionProps,
  type SingleValue,
  SingleValueProps,
} from 'react-select'
import { FC } from 'react'
import { languageList } from './languageList'
import { SelectInput, SelectOption } from '../Generic/SelectInput/SelectInput'
import { FlagEmoji } from '../Generic/FlagEmoji/FlagEmoji'
import './LanguageSelect.css'

const { Input, Option, SingleValue } = components

export interface SelectInputProps {
  onChange?: (option: string) => void
  options?: string[]
  value?: string
  classNamePrefix?: string
  height?: number
  width?: number
  disabled?: boolean
  languageMode?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  className?: any
  borderRadius?: string
  borderWidth?: string
  borderColor?: string
  color?: string
  colorDisabled?: string
  backgroundColor?: string
  borderColorFocus?: string
  colorFocus?: string
  backgroundColorFocus?: string
  colorSelected?: string
  backgroundColorSelected?: string
}

const CustomOption: FC<OptionProps<SelectOption, boolean, GroupBase<SelectOption>>> = (props) => {
  const { data } = props

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { value, label } = data

  return (
    <Option {...props}>
      <div className="language-select__item-inner">
        {value && (
          <span className="language-select__flag">
            <FlagEmoji emoji={languageList[value as keyof typeof languageList]?.flag || ''} />
          </span>
        )}
        <span>{label}</span>
      </div>
    </Option>
  )
}

const LanguageSingleValue: FC<SingleValueProps<SelectOption, boolean, GroupBase<SelectOption>>> = (
  props
) => {
  const { data } = props

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { value, label } = data

  return (
    <SingleValue {...props}>
      <div className="language-select__item-inner">
        {value && (
          <span className="language-select__flag">
            <FlagEmoji emoji={languageList[value as keyof typeof languageList]?.flag || ''} />
          </span>
        )}
        <span>{label}</span>
      </div>
    </SingleValue>
  )
}

export const LanguageSelect: FC<SelectInputProps> = ({
  onChange,
  options,
  value,
  classNamePrefix,
  height,
  width,
  disabled,
  className,
  borderRadius,
  borderWidth,
  color,
  colorDisabled,
  borderColor,
  backgroundColor,
  borderColorFocus,
  colorFocus,
  backgroundColorFocus,
  colorSelected,
  backgroundColorSelected,
}) => {
  const onChangeHandler = (e: SingleValue<SelectOption> | MultiValue<SelectOption>) => {
    if (e && !Array.isArray(e)) {
      onChange && onChange((e as SelectOption).value)
    }
  }

  const label = languageList[value as keyof typeof languageList]?.name || value

  const CustomInput = (props: InputProps<SelectOption, boolean, GroupBase<SelectOption>>) => (
    <Input {...props} autoComplete="off" />
  )

  const mappedOptions =
    options?.map((option) => {
      return {
        value: option,
        label: languageList[option as keyof typeof languageList].name,
      }
    }) || []

  return (
    <div className="language-select onboarding-country-select">
      <SelectInput
        options={
          options?.length
            ? mappedOptions
            : Object.entries(languageList).map(([key, value]) => ({
                value: key,
                label: value.name,
              }))
        }
        onChange={onChangeHandler}
        value={{
          value: value || '',
          label: label || '',
        }}
        classNamePrefix={classNamePrefix || 'select-input'}
        menuPlacement="auto"
        isDisabled={disabled}
        components={{
          Input: CustomInput,
          SingleValue: LanguageSingleValue,
          Option: CustomOption,
        }}
        className={className ? className : ''}
      />
    </div>
  )
}
